import { useMemo } from "react";
import moment from "moment";

const useProductData = (fetchData, totalBudget) => {
  const rawData = fetchData || {};
  const data = rawData.data || [];

  const formattedData = useMemo(() => {
    if (!Array.isArray(data)) {
      console.error("Data is not an array:", data);
      return [];
    }

    let lastDate = ""; // ตัวแปรเก็บวันที่ก่อนหน้า
    let cumulativeRemaining = totalBudget; // ตัวแปรสะสมค่า remaining

    return data.map((order, index) => {
      const costPrice = parseFloat(order.cost_price || "0.00");
      const revenue = parseFloat(order.revenue || "0.00");
      const expenditure = parseFloat(order.expenditure || "0.00");
      const profitFromSelling = parseFloat(order.profit_from_selling || "0.00");
      const profitFromInterest = parseFloat(
        order.profit_from_interest || "0.00"
      );
      const profitFromPenalty = parseFloat(order.profit_from_penalty || "0.00");

      const profitSum =
        profitFromSelling + profitFromInterest + profitFromPenalty;
      const currentRemaining =
        revenue -
        expenditure 
        // profitFromSelling +
        // profitFromInterest +
        // profitFromPenalty;

      // สะสมค่าที่ต้องการ
      cumulativeRemaining += currentRemaining;

      // จัดการวันที่
      const formattedDate = order.created_date
        ? moment(order.created_date).format("DD/MM/YYYY")
        : "";
      const displayDate = formattedDate !== lastDate ? formattedDate : "";
      lastDate = formattedDate;

      return {
        id: index + 1,
        order_id: order.order_id || "",
        order_code: order.order_code || "",
        cost_price: costPrice.toFixed(2),
        revenue: revenue.toFixed(2),
        expenditure: expenditure.toFixed(2),
        profit_from_selling: profitFromSelling.toFixed(2), // ใช้ค่าที่สะสม
        profit_from_interest: profitFromInterest.toFixed(2),
        profit_from_penalty: profitFromPenalty.toFixed(2),
        profit_sum: profitSum.toFixed(2),
        remaining: cumulativeRemaining.toLocaleString(), // ใช้ค่าที่สะสม
        date: displayDate, // แสดงวันที่เฉพาะเมื่อไม่ซ้ำ
        actions: order.actions || "",
      };
    });
  }, [data]);

  return formattedData;
};

export default useProductData;
